import {
    useEffect,
    useState
} from 'react';
import * as S from './styled';
import { useChat } from '../../../../../../contexts/chat';
import {
    Card
} from './components/Card';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {
    reorderCostumerServiceInWaitingRoom
} from '../../../../../../service/serviceChat/waitingRoom';

export function WaitingRoom(props) {

    const { isVisibility } = props;

    const {
        onFilter,
        waitingRoom,
        onSearchWaitingRoom,
        idChat,
        resetChat
    } = useChat();

    const [costumerServiceInRoom, setCostumerServiceInRoom] = useState([]);
    const [isReorderingEnabled, setIsReorderingEnabled] = useState(false);

    useEffect(() => {
        onSearchWaitingRoom();
    }, [])
    useEffect(() => {
        setCostumerServiceInRoom([...waitingRoom]);
    }, [waitingRoom]);
    useEffect(() => {
        if (!isVisibility) return
        if (!costumerServiceInRoom) return
        const isChatOpen = costumerServiceInRoom?.some(item => item.client_phone === idChat)
        if (!isChatOpen) {
            resetChat();
        }
    }, [costumerServiceInRoom]);

    function handleOnDragEnd(result) {
        if (!isReorderingEnabled || !result.destination) return;
        const items = Array.from(costumerServiceInRoom);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setCostumerServiceInRoom(items);
    }

    async function handleSaveNewOrder() {
        setIsReorderingEnabled(false);
        const ids = costumerServiceInRoom.map((item) => item.id);
        await reorderCostumerServiceInWaitingRoom(ids);
    }
    function handleCancelNewOrder() {
        setIsReorderingEnabled(false);
        setCostumerServiceInRoom(waitingRoom);
    }

    return (
        <S.Container $isVisibility={isVisibility}>
            <S.Reorder $isVisibility={(costumerServiceInRoom.length > 1)}>
                {isReorderingEnabled
                    ? <>
                        <button
                            onClick={() => handleSaveNewOrder()}
                            className='salveReorder'
                        >
                            Salvar
                        </button>
                        |
                        <button
                            onClick={() => handleCancelNewOrder()}
                            className='cancelReorder'
                        >
                            Cancelar
                        </button>
                    </>
                    : <button
                        onClick={
                            () => setIsReorderingEnabled(!isReorderingEnabled)
                        }>
                        Reordenar
                    </button>
                }
            </S.Reorder>
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="serviceInRoom">
                    {(provided) => (
                        <S.List
                            $reorderActive={isReorderingEnabled}
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {costumerServiceInRoom.filter(onFilter)
                                .map((item, index) => {
                                    return (
                                        <Draggable
                                            key={item.id}
                                            draggableId={`${item.id}`}
                                            index={index}
                                            isDragDisabled={!isReorderingEnabled}
                                        >
                                            {(provided) => {
                                                return (
                                                    <S.Item
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        {isReorderingEnabled && <div className='banner' />}
                                                        <Card
                                                            key={item.id}
                                                            active={(
                                                                idChat === item?.customer_services[0].client_phone
                                                            )}
                                                            room={item}
                                                            index={index}
                                                        />
                                                    </S.Item>
                                                )
                                            }}
                                        </Draggable>
                                    );
                                })}
                            {provided.placeholder}
                        </S.List>
                    )}
                </Droppable>
            </DragDropContext>
        </S.Container >
    )
}